import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Initialize fbq
    const initFbq = () => {
      if ((window as any).fbq) return;
      const n = ((window as any).fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      }) as any;
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
    };
    initFbq();
    // Load the script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    script.onload = () => {
      const fbq = (window as any).fbq;
      if (fbq) {
        fbq('init', '2043786956475160');
        fbq('track', 'PageView');
      }
    };
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);
  return <noscript data-id="element-165">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=2043786956475160&ev=PageView&noscript=1" alt="" data-id="element-166" />
    </noscript>;
}